import axiosInstance from './axiosInstance'
import { ApiResponse, Connection, ConnectionRequest, PagedResponse } from '../types'

export const connectionApi = {
  sendRequest: (userId: number, message?: string) =>
    axiosInstance.post<ApiResponse<ConnectionRequest>>(`/connections/request/${userId}`, { message }),

  acceptRequest: (requestId: number) =>
    axiosInstance.post<ApiResponse<Connection>>(`/connections/accept/${requestId}`),

  rejectRequest: (requestId: number) =>
    axiosInstance.post<ApiResponse<void>>(`/connections/reject/${requestId}`),

  getConnections: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<Connection>>>(`/connections?page=${page}&size=${size}`),

  getPendingRequests: (page = 0, size = 20) =>
    axiosInstance.get<ApiResponse<PagedResponse<ConnectionRequest>>>(
      `/connections/requests/pending?page=${page}&size=${size}`
    ),

  getConnectionStatus: (userId: number) =>
    axiosInstance.get<ApiResponse<{ status: string }>>(`/connections/status/${userId}`),
}
